import React from 'react';
import { Text, Preset, FunctionColor } from '@lux/text';
import { Kicker } from '@lux/kicker';
import { Translate } from '@pegasus/translation';
import { useCampaignTimer } from '@browsing/hooks';

export interface TimeLeftProps {
    dateTill: number;
    expireCallback?: () => void;
}

const pad2 = (number: number) => `0${number}`.slice(-2);

const TimeLeft = ({ dateTill, expireCallback }: TimeLeftProps) => {
    const { days, hours, minutes, seconds } = useCampaignTimer(dateTill, expireCallback);

    const prefix = 'timeLeft.endsIn';

    return (
        <Kicker title={<Translate message={prefix} />} titlePreset={Preset.XS}>
            <Text color={FunctionColor.function100} preset={Preset.M} bold translate="no">
                {days >= 1 ? (
                    <Translate
                        message="timeLeft.ticksDayHourFormatShort"
                        params={{ days, hours, minutes }}
                        html
                    />
                ) : (
                    <Translate
                        message="timeLeft.ticksTimerFormatShort"
                        params={{
                            hours,
                            minutes: pad2(minutes),
                            seconds: pad2(seconds),
                        }}
                        html
                    />
                )}
            </Text>
        </Kicker>
    );
};

export default TimeLeft;
